// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ToolsMenu-cls1__bcd15a7a59f6254ea664{/*!*/}.ToolsMenu-cls2___696a44d97e6413f14e3{list-style:none;padding:0;margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ToolsMenu-cls1__bcd15a7a59f6254ea664",
	"cls2": "ToolsMenu-cls2___696a44d97e6413f14e3 ToolsMenu-cls1__bcd15a7a59f6254ea664"
};
export default ___CSS_LOADER_EXPORT___;
